import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import useLoginCheck from "./util/useLoginCheck";

const Login = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const url = `${process.env.REACT_APP_LISTOGRAPHY_API_PREFIX}/api/login`;

  useLoginCheck();

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      console.log("url is ", url);
      const response = await axios.post(url, {
        username,
        password,
      });

      if (response.data && response.data.jwt) {
        console.log("response from login: ", response);
        localStorage.setItem("token", response.data.jwt);
        navigate("/dashboard");
      } else {
        setError(
          "Book Notes is experiencing technical difficulties. Try again later."
        );
      }
    } catch (error) {
      console.error("Login error:", error);
      setError("Looks like you don't know your credentials?");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-sm mx-auto p-4 mt-20">
      <div className="card p-6">
        <h2 className="text-lg font-semibold text-stone-800 mb-4 text-center">
          Listography
        </h2>
        <form onSubmit={handleLogin} className="space-y-3">
          <input
            type="text"
            placeholder="Username"
            className="w-full border border-stone-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-teal-600"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            required
          />
          <input
            type="password"
            placeholder="Password"
            className="w-full border border-stone-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-teal-600"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
          <button type="submit" disabled={loading} className="btn-primary w-full">
            {loading ? "Logging in..." : "Log in"}
          </button>
          {error && <p className="text-sm text-red-600">{error}</p>}
        </form>
      </div>
    </div>
  );
};
export default Login;
